import { Slideout } from "@arelia-components/ui-atoms/Slideout";
import { ChatBubbleOutlineOutlined } from "@mui/icons-material";
import { Box, Button, IconButton, Paper, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ChatLine, useAiChatMutation } from "src/api/ai";
import theme from "src/theme";
import { useScrollToBottom } from "../../hooks/useScrollToBottom";

export function ChatSlideout() {
    const [open, setOpen] = useState(false);
    const [lines, setLines] = useState<ChatLine[]>([]);
    const [message, setMessage] = useState("");
    const [systemMessage, setSystemMessage] = useState("");
    const linesRef = useRef<HTMLTextAreaElement>(null);
    const aiChat = useAiChatMutation({
        onSuccess: (data) => setLines(data)
    });

    useEffect(() => send(true), []);
    useScrollToBottom(linesRef, [lines]);

    const send = (reset: boolean = false) => {
        const systemLines: ChatLine[] = !!systemMessage ? [{ role: 'system', content: systemMessage }] : [];
        const newLines: ChatLine[] = reset ?
            systemLines :
            [...systemLines, ...lines, { role: "user", content: message }];
        aiChat.mutate(newLines);
        setLines(newLines);
        setMessage("");
    } 

    return <>
        <IconButton color="success" onClick={() => setOpen(x => !x)}>
            <ChatBubbleOutlineOutlined />
        </IconButton>
        <Slideout title="Chat GPT" open={open} setOpen={setOpen} icon={<ChatBubbleOutlineOutlined color="success" />}>
            <Box display="flex" flexDirection="column" px="30px" justifyContent="flex-end">
                <TextField multiline rows={3} sx={{ flexGrow: 1, mb: 2, p: 0 }}
                    value={systemMessage}
                    onChange={(e) => setSystemMessage(e.target.value)}
                ></TextField>
                <Button variant="outlined" onClick={() => send(true)}>
                    Reset System Prompt
                </Button>
                <hr />
            </Box>
            <Box ref={linesRef} display="flex" padding="30px" flexDirection="column" flexGrow={1} sx={{ overflowX: 'auto' }}>
                {lines.filter(l => l.role !== "system").map(line => (
                    line.role === "assistant" ? (
                        <Paper elevation={2} sx={{ p: 2, mr: 5, mb: 2 }}>
                            <b>AI Assistant:</b> <div dangerouslySetInnerHTML={{ __html: line.content.replaceAll('\n', '<br>') }}></div>
                        </Paper>
                    ) : (
                        <Box pl={4} display="flex">
                            <Paper elevation={2} sx={{ p: 1, ml: "auto", mb: 2, textAlign: "right", backgroundColor: theme.palette.primary.main, color: "white" }}>
                                <div dangerouslySetInnerHTML={{ __html: line.content.replaceAll('\n', '<br>') }}></div>
                            </Paper>
                        </Box>
                    )

                ))}
            </Box>
            <Box display="flex" padding="30px" justifyContent="flex-end">
                <TextField sx={{ flexGrow: 1, mr: 2 }} placeholder="Ask me anything..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                ></TextField>
                <Button variant="contained" onClick={() => send()}>
                    SEND
                </Button>
            </Box>

        </Slideout >
    </>;
}